import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { Voucher, VouchersToApply } from '../models';

export class VoucherState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public voucher: Voucher[];
  public voucherAutoApplyResponse: Object;
  public loyaltyVouchersToApply: VouchersToApply[];

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.voucher = [];
    this.voucherAutoApplyResponse = null;
    this.loyaltyVouchersToApply = [];
  }
}
